import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MenuSelector from './MenuSelector';
import { DEFAULT_LANG } from './utils/constants';
import { getOrderedLanguages } from './utils/utils';

class LanguageSelector extends Component {

  state = {
    selected: this.props.selectedLang && this.props.langs.includes(this.props.selectedLang) ?
      this.props.selectedLang
      :
      this.props.langs.includes(this.props.defaultLang) &&
        (!this.props.excludeLangs || !this.props.excludeLangs.includes(this.props.defaultLang)) ?
        this.props.defaultLang
        :
        "",
    langs: getOrderedLanguages(this.props.langs, DEFAULT_LANG)
  };

  handleChange = (value) => this.props.onSelect(value);

  render() {

    const { langs, selected } = this.state;
    const { autoFocus, includeLabel, multiple, excludeNoLanguage, disabled, label, excludeLangs } = this.props;

    let filteredLangs = langs;
    if (excludeNoLanguage) {
      filteredLangs = filteredLangs.filter(lang => lang.code !== "und");
    }
    if (excludeLangs) {
      filteredLangs = filteredLangs.filter(lang => !excludeLangs || !excludeLangs.includes(lang.code));
    }

    return (
      <MenuSelector
        disabled={disabled}
        dataTest="language-selector"
        label={includeLabel ? label : null}
        autoFocus={autoFocus}
        handleChange={this.handleChange}
        selected={selected}
        hintWord="language"
        multiple={multiple}
        options={filteredLangs.map(lang => {
          return {
            value: lang.code,
            label: lang.label
          };
        })} />
    );
  }
}

LanguageSelector.defaultProps = {
  autoFocus: false,
  includeLabel: true,
  label: "Language",
  multiple: false,
  disabled: false,
  excludeLangs: [],
  excludeNoLanguage: false
};

LanguageSelector.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  excludeNoLanguage: PropTypes.bool,
  multiple: PropTypes.bool,
  includeLabel: PropTypes.bool,
  langs: PropTypes.array.isRequired,
  excludeLangs: PropTypes.array,
  selectedLang: PropTypes.string,
  defaultLang: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default LanguageSelector;